var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BNav'),_c('main',{staticClass:"margin-horizontal-big margin-horizontal-lg-xxbig"},[_c('h1',{staticClass:"font-size-big margin-vertical-xbig"},[_vm._v(" Pesquisa de satisfação ")]),_c('CsatForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }